module.exports = __webpack_public_path__ + "img/DE.7216f3af.svg";